import { bus } from '@core/events/eventSystem';
import { EVENTS, ENDPOINTS } from './constants';

class CheckoutController {
  constructor() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Handle checkout launch from store (kingrecharge store flow)
    bus.on('checkout:launch', async (data) => {
      const { cartState, userData } = data;

      // Simulate payment processing delay
      setTimeout(() => {
        // In a real app, this would call the payment API
        // For simulation, we'll emit a success response
        bus.emit('checkout:payment:launched', {
          paymentUrl: null, // No redirect for simulation
          success: true,
          orderId: 'ORD-' + Date.now(),
          amount: cartState?.total || 0
        });
      }, 1500);
    });

    // Create order
    bus.on(EVENTS.CHECKOUT.CREATE_ORDER, async (orderData) => {
      // Mock order creation
      bus.emit(EVENTS.CHECKOUT.START, orderData.ticket);

      // Simulate processing delay
      setTimeout(() => {
        bus.emit(EVENTS.CHECKOUT.CREATE_ORDER_SUCCESS, {
          orderId: 'ORD-' + Date.now(),
          ticketId: orderData.ticket.id,
          quantity: orderData.quantity,
          attendees: orderData.attendees,
          total: orderData.ticket.price * orderData.quantity
        });
      }, 500);
    });

    // Process payment
    bus.on(EVENTS.CHECKOUT.PROCESS_PAYMENT, async (paymentData) => {
      // Mock payment processing
      setTimeout(() => {
        bus.emit(EVENTS.CHECKOUT.PROCESS_PAYMENT_SUCCESS, {
          paymentId: 'PAY-' + Date.now(),
          orderId: paymentData.orderId,
          amount: 15000, // Mock amount
          currency: 'XOF',
          status: 'confirmed'
        });

        // Also emit order success to move to confirmation step
        bus.emit(EVENTS.CHECKOUT.CREATE_ORDER_SUCCESS, {
          orderId: paymentData.orderId || 'ORD-' + Date.now(),
          paymentId: 'PAY-' + Date.now(),
          status: 'confirmed'
        });
      }, 1500); // Simulate payment processing
    });

    // Validate promo code
    bus.on(EVENTS.CHECKOUT.APPLY_PROMO, async (code) => {
      setTimeout(() => {
        if (code === 'BIENVENUE10') {
          bus.emit(EVENTS.CHECKOUT.APPLY_PROMO_SUCCESS, {
            code: 'BIENVENUE10',
            discount: 10,
            type: 'fixed'
          });
        } else if (code === 'SUMMER20') {
          bus.emit(EVENTS.CHECKOUT.APPLY_PROMO_SUCCESS, {
            code: 'SUMMER20',
            discount: 20,
            type: 'percent'
          });
        } else {
          bus.emit(EVENTS.CHECKOUT.APPLY_PROMO_ERROR, {
            message: 'Code promo invalide',
            details: 'Ce code n\'existe pas ou a expiré'
          });
        }
      }, 300);
    });

    // Fetch payment methods
    bus.on(EVENTS.CHECKOUT.FETCH_PAYMENT_METHODS, async () => {
      setTimeout(() => {
        bus.emit(EVENTS.CHECKOUT.PAYMENT_METHODS_LOADED, [
          { id: 'card', name: 'Carte bancaire', enabled: true },
          { id: 'paypal', name: 'PayPal', enabled: true },
          { id: 'apple', name: 'Apple Pay', enabled: true }
        ]);
      }, 200);
    });
  }
}

// Auto-instantiate when imported
const checkoutController = new CheckoutController();

export default checkoutController;
